import React from "react"
import classnames from "classnames"
import { Modal, Icon, Tooltip, Select } from "antd"
import prettysize from "../../utils"

import BullhornIcon from "../../assets/img/bullhorn-font-awesome.png"
import BullhornInvertedIcon from "../../assets/img/bullhorn-inverted-font-awesome.png"

import PencilIcon from "../../assets/img/edit.svg"
import PencilInvertedIcon from "../../assets/img/pencil-inverted-font-awesome.png"
import TrashIcon from "../../assets/img/trash.svg"
import TrashInvertedIcon from "../../assets/img/trash-o-inverted-font-awesome.png"
import BucketIcon from "../../assets/img/bucket.svg"

import google from "../../assets/logo/google-logo.png"
import aws from "../../assets/logo/Aws-icon.svg"
import wasabi from "../../assets/logo/Wasabi-icon.svg"
import azure from "../../assets/logo/Azure-icon.svg"
import backblaze from "../../assets/logo/Blaze-icon.svg"
import s3 from "../../assets/logo/s3-selected.png"
import filebase from "../../assets/logo/filebase-icon.png"

import BBStep1 from "../../assets/img/billing-bucket-step1.png"
import BBStep2 from "../../assets/img/billing-bucket-step2.png"
import StorageList from "./storage-list"
import CloudFlyerAPI from "../../api/CloudFlyerAPI"
import "./account-list.scss";

const icons = {
  1:aws,
  2:wasabi,
  4:azure,
  8:s3,
  16:google,
  32:filebase
}

let ref = ""
export default ({
  items,
  filter,
  expandedItemId,
  history,
  handleExpandClick,
  handleDeleteCAClick,
  on_show_compare,
  on_bucket_refresh,
  bucket_refreshing
  
}) => (
  
  <div className="account-list noselect">
    <div className="header">
      <h3>Active Cloud Providers</h3>
    </div>

    <div className="table-header">
      <p>Name</p>
      <p>Storage</p>
      {/* <p>Usage</p> */}
      <p>Actions</p>
      <p> </p>
    </div>

    {(filter.items || items).map(item => {
      item.expanded = item.id === expandedItemId
      return (
        <Item
          key={item.id}
          item={item}
          history={history}
          refreshing={bucket_refreshing}
          handleExpandClick={handleExpandClick}
          handleDeleteCAClick={handleDeleteCAClick}
          on_show_compare={() => on_show_compare(item)}
          on_refresh={on_bucket_refresh}
        />
      )
    })}
  </div>
)

const Item = ({
  item,
  handleExpandClick,
  handleDeleteCAClick,
  on_show_compare,
  history,
  on_refresh,
  refreshing
}) => {
  if (item.total_cost) {
    item.forecast =
      (item.total_cost / new Date().getDate()) *
      new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 1,
        0
      ).getDate()
  }

  return (
    
    <div
      className={classnames("row", { expanded: item.expanded })}
      onClick={handleExpandClick.bind(null, item.id)}
    >
      {/* <p>{item.accountId}</p> */}
      <p className="provider">
        {
          item.serviceUrl === 'https://s3.filebase.com' ? <img src={icons[32]} alt="" /> : <img src={icons[item.cloudType]} alt="" />
        }
        
        {/* <Tooltip title={item.name}> */}
        <Tooltip>
          <span className={"ellipsis"}>{item.name}</span>
        </Tooltip>
      </p>

      {/*<p>{item.vm ? item.vm.running + item.vm.stopped : ''}</p>*/}
      <p>{item.bucket_count ? item.bucket_count + (item.cloudType == 4 ? " Containers" : " Buckets") : ""}</p>
      {/* <p>{item.account ? item.account + " Buckets" : "NO Buckets"}</p> */}



      {/* Usage field ================================================= */}
      {/* <p className="usage success">
        {item.account_type_id === "aws" &&
        !item.billing_bucket &&
        item.storages &&
        item.storages.length > 0 &&
        !item.expanded ? (
          <Tooltip title="Billing Bucket is not set">
            <Icon
              type="warning"
              style={{ cursor: "pointer" }}
              onClick={e =>
                showSetBBModal(e, {
                  projectName: item.project_name,
                  storages: item.storages,
                  handleSetBBSave: () => {
                    if (ref !== "") {
                      // if the user has selected a bulling bucket
                      Modal.info({
                        title: "Setting up billing bucket",
                        content: "Your costs and usage will show in moments"
                      })
                      CloudFlyerAPI.new_cloud_accounts
                        .setBillingBucket(item.id, ref)
                        .then(() => on_refresh())
                    }
                  },
                  handleChange: value => (ref = value)
                })
              }
            />
          </Tooltip>
        ) : item.total_bytes_used ? (
          prettysize(item.total_bytes_used)
        ) : (
          ""
        )}
      </p> */}
      {/* ================================================= */}

      {/*<p>{item.total_cost ? ('$' + item.total_cost.toFixed(3)) : ''}</p>
      <p>{item.total_cost ? ('$' + item.forecast.toFixed(2)) : ''}</p>
      <p>{item.account_type_id === 'wasabi' ? '0.0049' : (item.per_gb ? ('$' + item.per_gb.toFixed(3)) : '')}</p>*/}
      
      {item.expanded ? (
        <InversedRowActions
          projectName={item.project_name}
          cloudAccountId={item.id}
          accountTypeId={item.account_type_id}
          history={history}
          handleDeleteCAClick={handleDeleteCAClick}
        />
      ) : (
        <RowActions
          projectName={item.name}
          cloudAccountId={item.id}
          accountTypeId={item.account_type_id}
          history={history}
          item={item}
          handleDeleteCAClick={handleDeleteCAClick}
          on_show_compare={on_show_compare}
        />
      )}

      <p className="expand">
        <Tooltip title={item.expanded ? "collapse" : "expand"}>
          <Icon type={item.expanded ? "up" : "down"} />
        </Tooltip>
      </p>

      {item.expanded && (
        <StorageList
          cloud={item}
          storages={item.storages}
          history={history}
          refreshing={refreshing}
          on_refresh={() => on_refresh(item.id)}
        />
      )}
    </div>
  )
}

const RowActions = ({
  handleDeleteCAClick,
  on_show_compare,
  cloudAccountId,
  projectName,
  accountTypeId,
  item,
  history
}) => (
  <p className="row-actions">
  {/* Notification Icon ----------------------------------- */}
    {/* <Tooltip title="Set Notifications">
      <img
        src={BullhornIcon}
        alt=""
        onClick={e => {
          e.stopPropagation()
          history.push(`/setAlert/${cloudAccountId}`)
        }}
      />
    </Tooltip> */}
    {/* <Tooltip title="Edit">
      <img
        src={PencilIcon}
        alt=""
        onClick={e => {
          e.stopPropagation()
          history.push(`/addProvider/${accountTypeId}/${cloudAccountId}`)
        }}
      />
    </Tooltip> */}
    {accountTypeId === "aws" || accountTypeId === "wasabi" ? (
      <Tooltip title="Create a Bucket">
        <img
          src={BucketIcon}
          alt=""
          height="18px"
          onClick={e => {
            e.stopPropagation()
            history.push(`/addBucket/${accountTypeId}/${cloudAccountId}`)
          }}
        />
      </Tooltip>
    ) : null}
    <Tooltip title="Delete">
      <img
        src={TrashIcon}
        alt=""
        onClick={e =>
          showDeleteConfirm(e, handleDeleteCAClick, cloudAccountId, projectName)
        }
      />
    </Tooltip>
    {/*{
      <Tooltip title='Compare prices between cloud storage providers' placement={'left'}>
        <FontAwesome className={'compare'} name='balance-scale' onClick={
          e => {
            e.stopPropagation()
            history.push(`/cloud-compare/${cloudAccountId}`)
          }}/>
      </Tooltip>
    }*/}
  </p>
)

/*<Button shape="circle" onClick={on_show_compare}></Button>*/
const InversedRowActions = ({
  handleDeleteCAClick,
  cloudAccountId,
  projectName,
  accountTypeId,
  history
}) => (
  <p className="child-actions">
    {/* <Tooltip title="Set Notifications">
      <img
        src={BullhornInvertedIcon}
        alt=""
        onClick={e => {
          e.stopPropagation()
          history.push(`/setAlert/${cloudAccountId}`)
        }}
      />
    </Tooltip> */}
    {/* <Tooltip title="Edit">
      <img
        src={PencilInvertedIcon}
        alt=""
        onClick={e => {
          e.stopPropagation()
          history.push(`/addProvider/${accountTypeId}/${cloudAccountId}`)
        }}
      />
    </Tooltip>
    <Tooltip title="Delete">
      <img
        src={TrashInvertedIcon}
        alt=""
        onClick={e =>
          showDeleteConfirm(e, handleDeleteCAClick, cloudAccountId, projectName)
        }
      />
    </Tooltip> */}
  </p>
)

const showDeleteConfirm = (
  e,
  handleDeleteCAClick,
  cloudAccountId,
  projectName
) => {
  e.stopPropagation()
  Modal.confirm({
    title: `Do you want to remove the ${projectName} cloud account?`,
    content:
      "",
    onOk() {
      handleDeleteCAClick(cloudAccountId)
    }
  })
}

const showSetBBModal = (
  e,
  { projectName, storages, handleSetBBSave, handleChange }
) => {
  e.stopPropagation()
  Modal.info({
    title: `Set up billing bucket for ${projectName} cloud account.`,
    content: (
      <div className="set-bb-modal">
        <p>
          You need to configure a billing bucket to add the costs information to
          your AWS account.
        </p>
        <p>Before selecting a bucket, you must configure it manually in AWS.</p>
        <div>
          <Select dropdownMatchSelectWidth={false} onChange={handleChange}>
            {storages.map(s => (
              <Select.Option key={s.id} value={s.bucket_name}>
                {s.bucket_name}
              </Select.Option>
            ))}
          </Select>
        </div>

        <br />
        <h4>How to manually configure billing bucket in AWS :</h4>
        {/*<p>Enable billing reports to S3 on the target AWS account from the Billing Preferences page in the AWS console:</p>*/}
        <div>
          <ol>
            <li>Go to the Billing Preferences page in the AWS console.</li>
            <li>
              Enable <i>Receive Billing Reports</i> by checking the box.
            </li>
            <li>
              Enter the exact name of the bucket which will receive the billing
              reports in the box. We recommend that you create a new empty
              bucket for the billing reports as many files will be created
              within it. Click Verify to ensure the bucket exists. <br />
              3a. Copy the sample policy to be added to the bucket in the S3
              console (shown below).
            </li>
            <li>Enable all report types.</li>
          </ol>
          <img src={BBStep1} alt="" />
          <ol>
            <li>
              Click the magnifying glass icon to open the properties for the
              bucket you entered in step above.
            </li>
            <li>Click to Edit the bucket policy.</li>
            <li>Paste the sample bucket policy from step 3a above.</li>
          </ol>
          <img src={BBStep2} alt="" />
        </div>
      </div>
    ),
    className: "set-bb-content",
    onOk() {
      handleSetBBSave()
    }
  })
}
